let serverUrl = "https://potnvehiclefinder.co.uk";
let carPageUrl = "https://www.ebcbrakeshop.co.uk/pages/car-search";
let bikePageUrl = "https://www.ebcbrakeshop.co.uk/pages/bike-search";

// delivery timer
document.addEventListener("DOMContentLoaded", () => {
  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  function getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  }

  function isHoliday(dateUtcAsUkWallClock) {
    // dateUtcAsUkWallClock is a Date where UTC fields represent UK wall-clock fields
    const holidays = []; // e.g. ["2026-12-25", "2026-12-26"]
    const y = dateUtcAsUkWallClock.getUTCFullYear();
    const m = String(dateUtcAsUkWallClock.getUTCMonth() + 1).padStart(2, "0");
    const d = String(dateUtcAsUkWallClock.getUTCDate()).padStart(2, "0");
    return holidays.includes(`${y}-${m}-${d}`);
  }

  // Returns a Date where UTC fields == UK wall-clock fields (safe for math globally)
  function getUKNowAsUtcDate() {
    const now = new Date();
    const dtf = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/London",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    const parts = dtf.formatToParts(now);
    const get = (type) => Number(parts.find(p => p.type === type).value);

    const year = get("year");
    const month = get("month"); // 1-12
    const day = get("day");
    const hour = get("hour");
    const minute = get("minute");
    const second = get("second");

    return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
  }

  function getMonthNameFromUtcDate(dateUtcAsUkWallClock) {
    // We want UK month name; use UTC fields to avoid local TZ shifts
    const y = dateUtcAsUkWallClock.getUTCFullYear();
    const m = dateUtcAsUkWallClock.getUTCMonth(); // 0-11
    const d = dateUtcAsUkWallClock.getUTCDate();
    const safe = new Date(Date.UTC(y, m, d, 12, 0, 0)); // noon avoids edge cases
    return new Intl.DateTimeFormat("en-GB", { month: "short", timeZone: "Europe/London" }).format(safe);
  }

  function updateCountdown() {
    const now = getUKNowAsUtcDate();

    // "Today at midnight" in UK wall clock (stored in UTC fields)
    const targetTime = new Date(Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      0, 0, 0, 0
    ));

    let deliveryDay;

    // Your rules, rewritten with UTC methods
    if (now.getUTCDay() === 4 && now.getUTCHours() > 12) {
      // Thursday after 12
      targetTime.setUTCDate(now.getUTCDate() + 3);
      targetTime.setUTCHours(12, 0, 0, 0);
      deliveryDay = new Date(targetTime.getTime());
    } else if (now.getUTCDay() === 5) {
      // Friday
      targetTime.setUTCDate(now.getUTCDate() + 2);
      targetTime.setUTCHours(12, 0, 0, 0);
      deliveryDay = new Date(targetTime.getTime());
    } else if (now.getUTCDay() === 6) {
      // Saturday
      targetTime.setUTCDate(now.getUTCDate() + 1);
      targetTime.setUTCHours(12, 0, 0, 0);
      deliveryDay = new Date(targetTime.getTime());
    } else {
      if (now.getUTCHours() < 12) {
        // before 12 UK -> cut-off today 12, delivery tomorrow
        targetTime.setUTCHours(12, 0, 0, 0);
        deliveryDay = new Date(targetTime.getTime());
        deliveryDay.setUTCDate(deliveryDay.getUTCDate() + 1);
      } else {
        // after 12 UK -> cut-off tomorrow 12, delivery day after tomorrow
        targetTime.setUTCDate(targetTime.getUTCDate() + 1);
        targetTime.setUTCHours(12, 0, 0, 0);
        deliveryDay = new Date(targetTime.getTime());
        deliveryDay.setUTCDate(deliveryDay.getUTCDate() + 1);
      }
    }

    // Avoid Sundays + holidays (use UTC day)
    while (deliveryDay.getUTCDay() === 0 || isHoliday(deliveryDay)) {
      
      if (isHoliday(deliveryDay)) {
            targetTime.setUTCDate(targetTime.getUTCDate() + 1);
        }
        deliveryDay.setUTCDate(deliveryDay.getUTCDate() + 1);// Move to the next day if Sunday or a holiday.
    }

    // Update delivery text
    const dispatchText = document.querySelectorAll(".dispatch-text");
    const dayName = daysOfWeek[deliveryDay.getUTCDay()];
    const dateNum = deliveryDay.getUTCDate();
    const dateWithSuffix = dateNum + getOrdinalSuffix(dateNum);
    const monthName = getMonthNameFromUtcDate(deliveryDay);

    dispatchText.forEach((el) => {
      el.innerHTML = `for delivery ${dayName} ${dateWithSuffix} ${monthName}`;
    });

    // Countdown
    const timeDifference = targetTime.getTime() - now.getTime();
    const diff = Math.max(0, timeDifference);

    const hours = Math.floor(diff / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    document.querySelectorAll(".countdown-timer").forEach((el) => {
      el.innerHTML = `${hours}h ${minutes}m ${seconds}s`;
    });
  }

  setInterval(updateCountdown, 1000);
  updateCountdown();
});

function updateCartBubble() {
    fetch(`/?section_id=cart-icon-bubble`)
        .then((response) => response.text())
        .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newCartBubbleContent =
                doc.querySelector(".shopify-section").innerHTML;
            document.querySelector("#cart-icon-bubble").innerHTML =
                newCartBubbleContent;
        })
        .catch((err) => console.error("Failed to update cart bubble:", err));
}

function escapeCSS(id) {
    return id.replace(/([^\w-])/g, "\\$1");
}

const updateCartDrawer = async () => {
    await updateDrawer();
    openDrawer();
};

const updateDrawer = async () => {
    try {
        const response = await fetch(`/cart?sections=cart-drawer`);
        const text = await response.text();
        const json = JSON.parse(text);

        const html = json["cart-drawer"];
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newCartDrawerContent =
            doc.querySelector("cart-drawer").innerHTML;

        const drawer = document.querySelector("cart-drawer");

        drawer.innerHTML = newCartDrawerContent;
        drawer.classList.remove("is-empty");

    } catch (err) {
        console.error("Failed to update cart drawer:", err);
    }
};

const openDrawer = () => {
    const drawer = document.querySelector("cart-drawer");
    drawer && drawer.open();
};

function removeFilter(event) {
    let parentDiv = event.target.closest("div");
    let content = parentDiv.childNodes[0].textContent;
    let customFilterArr = document.querySelectorAll(".customFilter input");
    let result = Array.from(customFilterArr).filter(
        (element) => element.value.trim() == content.trim(),
    );
    result.forEach((element) => {
        element.checked = false;
        element.dispatchEvent(new Event("change"));
    });
    parentDiv.remove();
}

//-------- add to cart--------------//
function addToCart(variantId, event) {
    event.target.disabled = true;
    event.target.classList.add("loadingCart");
    event.target.nextElementSibling.classList.remove("hidden");
    let select = document.querySelector(`#quantitySelect_${variantId}`);
    let quantity = select.value;
    fetch(`/cart/add.js`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            id: variantId,
            quantity: quantity,
        }),
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            return response.json(); // This parses the JSON body of the response
        })
        .then((data) => {

            // drawer logic while click on collection page add-to-cart button.
            updateCartDrawer();
            updateCartBubble();

            event.target.disabled = false;
            event.target.classList.remove("loadingCart");
            event.target.nextElementSibling.classList.add("hidden");
        })
        .catch((error) => {
            console.error("Error adding item to cart:", error.message);
        });
}
